import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Team from 'components/team';


const TeamsRoute: React.FC = () =>
{
  return (
    <PermissionGuard
      permission={Team.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Teams />} />
        <Route path="/page/:pageNum" element={<Pages.Teams />} />
        <Route path="/page" element={<Pages.Teams />} />
        <Route path="/:id/*" element={<Pages.Team />} />
        <Route path="/create/*" element={<Pages.Team />} />
      </Routes>
    </PermissionGuard>
  );
};



export default TeamsRoute;
